!function(t) {
    "use strict";
    (g = y || (y = {})).Percentage = "percentage",
    g.FixedAmount = "fixed_amount",
    g.NoDiscount = "no_discount";
    let e = t => {
        var e;
        if (!t)
            return null;
        let i = t.closest(".product-bundle-item");
        return {
            quantity: Number(null == i ? void 0 : i.getAttribute("quantity")),
            discountValue: Number(null == i ? void 0 : i.getAttribute("discountValue")),
            discountType: null !== (e = null == i ? void 0 : i.getAttribute("discountType")) && void 0 !== e ? e : y.NoDiscount
        }
    }
      , i = t => ({
        discountPercentAmount: 0,
        discountAmount: window.Shopify.formatMoney(0, t)
    })
      , n = t => {
        var e, n, r, d;
        let {currentVariant: l, bundleItem: c, options: h} = t;
        if (!(null == h ? void 0 : h.useProductCompareAtPrice) && (null == c ? void 0 : c.discountType) === y.NoDiscount)
            return i(null !== (e = null == h ? void 0 : h.moneyFormat) && void 0 !== e ? e : "${{amount}}");
        if (!c || !(null == l ? void 0 : l.price))
            return i(null !== (n = null == h ? void 0 : h.moneyFormat) && void 0 !== n ? n : "${{amount}}");
        let p = Number(null == l ? void 0 : l.price)
          , v = Number(null == l ? void 0 : l.compare_at_price) || p
          , m = Number((null == c ? void 0 : c.quantity) || 1)
          , g = s(p, c)
          , _ = u(g, m * p)
          , f = p * m - g
          , T = v * m;
        return v <= p && g <= 0 ? i(null !== (r = null == h ? void 0 : h.moneyFormat) && void 0 !== r ? r : "${{amount}}") : {
            discountPercentAmount: (null == h ? void 0 : h.useProductCompareAtPrice) ? o(f, T) : _,
            discountAmount: (null == h ? void 0 : h.useProductCompareAtPrice) ? a(f, T, null == h ? void 0 : h.moneyFormat) : window.Shopify.formatMoney(g, null !== (d = null == h ? void 0 : h.moneyFormat) && void 0 !== d ? d : "${{amount}}")
        }
    }
      , r = t => {
        var e, i;
        let n = (null === (i = window) || void 0 === i ? void 0 : null === (e = i.Shopify.currency) || void 0 === e ? void 0 : e.rate) || 1;
        return Number(t * n * 100)
    }
      , o = (t, e) => Math.round((e - t) / e * 100)
      , a = (t, e, i) => window.Shopify.formatMoney(e - t, null != i ? i : "${{amount}}")
      , s = (t, e) => {
        let i = Number(null == e ? void 0 : e.discountValue);
        if ((null == e ? void 0 : e.discountType) === y.Percentage) {
            let n = Math.round(t * (1 - i / 100));
            return (t - n) * (e.quantity || 1)
        }
        return (null == e ? void 0 : e.discountType) === y.FixedAmount ? r(i) : 0
    }
      , u = (t, e) => Math.round(t / e * 100);
    function d(t, e, i) {
        return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = i,
        t
    }
    var l, c, h, p, v, m, g, y, _, f, T, b, C, E, A = () => class extends GP.Component {
        connectedCallback() {
            let t = this.closest("gp-product");
            if ((null == t ? void 0 : t.getState) && t.getState("isReady")) {
                this.rootInit();
                return
            }
            null == t || t.addEventListener("gp:product-init", () => {
                requestAnimationFrame( () => {
                    this.context = null == t ? void 0 : t.context,
                    this.rootInit()
                }
                )
            }
            )
        }
        constructor(t) {
            super(),
            d(this, "initFunc", void 0),
            d(this, "rootInit", () => {
                let t = this.closest(".gps > section");
                if (null == t ? void 0 : t.classList.contains("gps-lazy")) {
                    null == t || t.addEventListener("GpLazyLoaded", this.rootInit);
                    return
                }
                null == t || t.removeEventListener("GpLazyLoaded", this.rootInit),
                this.initFunc && this.initFunc()
            }
            ),
            this.initFunc = t
        }
    }
    ;
    function I(t, e, i) {
        return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = i,
        t
    }
    (l = _ || (_ = {})).CONTINUE = "continue",
    l.DENY = "deny",
    (c = f || (f = {})).EXACT = "exact",
    c.ABOVE = "above",
    c.BELOW = "below",
    c.EXACT_OR_ABOVE = "exact_or_above",
    c.EXACT_OR_BELOW = "exact_or_below",
    c.BETWEEN = "between",
    (h = T || (T = {})).INVENTORY_STATUS = "inventory_status",
    h.DISCOUNT_PRICE = "discount_price",
    h.PRICE_RANGE = "price_range",
    h.PRODUCT_TAGS = "product_tags",
    h.CREATION_DATE = "creation_date",
    (p = b || (b = {})).IN_STOCK = "in_stock",
    p.OUT_OF_STOCK = "out_of_stock",
    (v = C || (C = {})).DURATION = "duration",
    v.EXACT_DATE = "exact_date",
    v.BETWEEN_DATES = "between_dates",
    (m = E || (E = {})).PERCENT = "percent",
    m.FIXED = "fixed";
    var S = () => class extends A() {
        bundleHandler(t) {
            let {variantSelected: e, useProductCompareAtPrice: i} = t;
            if (null === this || void 0 === this || this.classList.remove(this.hiddenClass),
            !e)
                return;
            let {discountPercentAmount: r, discountAmount: o} = n({
                currentVariant: e,
                bundleItem: this.bundleItem,
                options: {
                    moneyFormat: this.getContext("moneyFormat"),
                    useProductCompareAtPrice: i
                }
            });
            r <= 0 || o <= 0 ? null === this || void 0 === this || this.classList.add(this.hiddenClass) : null === this || void 0 === this || this.classList.remove(this.hiddenClass);
            let a = this.getState("minPrice") || "0"
              , s = this.getInventoryQuantity(e)
              , u = this.dataset.displayContent || this.getState("displayContent") || ""
              , d = u.replaceAll("{percent_discount}", `${r}%`).replaceAll("{amount_discount}", o).replaceAll("{min_price}", a).replaceAll("{inventory_quantity}", s.toString())
              , l = this.querySelector("#product-badge-content");
            l && (l.innerHTML = d)
        }
        constructor() {
            var t;
            super( () => {
                this.init()
            }
            ),
            I(this, "displayTrigger", void 0),
            I(this, "variantIDs", void 0),
            I(this, "productCreatedAt", void 0),
            I(this, "productTags", []),
            I(this, "variantInventoryQuantities", void 0),
            I(this, "inventoryQuantity", void 0),
            I(this, "productEl", this.closest("gp-product")),
            I(this, "productBundleItem", this.closest(".product-bundle-item")),
            I(this, "bundleItem", void 0),
            I(this, "componentLoadCompleted", !1),
            I(this, "hiddenClass", ""),
            I(this, "applyInitialBadge", t => {
                this.inventoryQuantity = this.getInventoryQuantity(t),
                this.toggleBadge({
                    ...t,
                    product_created_at: this.productCreatedAt,
                    product_tags: this.productTags,
                    inventoryQuantity: this.inventoryQuantity
                }, this.displayTrigger),
                this.componentLoadCompleted = !0
            }
            ),
            I(this, "init", () => {
                if (!this.componentLoadCompleted) {
                    let t = this.getContext("variantSelected");
                    t && this.applyInitialBadge(t)
                }
                this.subscribeContext( (t, e) => {
                    var i, n;
                    if (!t.variantSelected) {
                        null === this || void 0 === this || this.classList.add(this.hiddenClass);
                        return
                    }
                    if (this.bundleItem) {
                        this.bundleHandler(t);
                        return
                    }
                    (null === (i = t.variantSelected) || void 0 === i ? void 0 : i.id) === (null === (n = e.variantSelected) || void 0 === n ? void 0 : n.id) && this.componentLoadCompleted || (this.componentLoadCompleted || (this.componentLoadCompleted = !0),
                    this.inventoryQuantity = this.getInventoryQuantity(t.variantSelected),
                    this.toggleBadge({
                        ...t.variantSelected,
                        product_created_at: this.productCreatedAt,
                        product_tags: this.productTags,
                        inventoryQuantity: this.inventoryQuantity
                    }, this.displayTrigger),
                    this.updateBadgeContent(t.variantSelected))
                }
                )
            }
            ),
            I(this, "updateBadgeContent", t => {
                var e;
                let i = null !== (e = this.getContext("moneyFormat")) && void 0 !== e ? e : "${{amount}}"
                  , {diffInPercent: n, diffInValue: r} = this.getProductPriceDiff(i, t.compare_at_price, t.price)
                  , o = this.getState("minPrice") || "0"
                  , a = this.getInventoryQuantity(t)
                  , s = this.dataset.displayContent || this.getState("displayContent") || ""
                  , u = s.replaceAll("{percent_discount}", n).replaceAll("{amount_discount}", r).replaceAll("{min_price}", o).replaceAll("{inventory_quantity}", a.toString())
                  , d = this.querySelector("#product-badge-content");
                d && (d.innerHTML = u)
            }
            ),
            I(this, "getProductPriceDiff", (t, e, i) => {
                if (e && i) {
                    let n = e ? e - i : 0
                      , r = Math.round(100 * n / e);
                    return {
                        diffInValue: window.Shopify.formatMoney(n, t),
                        diffInPercent: `${r}%`
                    }
                }
                return {
                    diffInValue: 0,
                    diffInPercent: "0%"
                }
            }
            ),
            I(this, "getInventoryQuantity", t => {
                if (null == t ? void 0 : t.inventoryQuantity)
                    return null == t ? void 0 : t.inventoryQuantity;
                let e = null == t ? void 0 : t.id
                  , i = this.convertToArray(this.getState("variantIDs"))
                  , n = this.convertToArray(this.getState("variantInventoryQuantities"));
                if (!(null == i ? void 0 : i.length) || !(null == n ? void 0 : n.length))
                    return 0;
                let r = i.findIndex(t => t === e);
                return n[r] || 0
            }
            ),
            I(this, "convertToArray", t => t && "string" == typeof t ? t.slice(1, -1).split(",").map(Number) : []),
            I(this, "checkShowBadge", (t, e) => {
                let i = null == e ? void 0 : e.map(e => {
                    switch (null == e ? void 0 : e.triggerEvent) {
                    case "inventory_status":
                        return this.inventoryTrigger(t, e);
                    case "discount_price":
                        return this.discountPriceTrigger(t, e);
                    case "price_range":
                        return this.priceRangeTrigger(t, e);
                    case "creation_date":
                        return this.creationDateTrigger(t, e);
                    case "product_tags":
                        return this.productTagsTrigger(t, e);
                    default:
                        return !1
                    }
                }
                );
                return null == i ? void 0 : i.every(t => !0 === t)
            }
            ),
            I(this, "toggleBadge", (t, e) => {
                let i = this.checkShowBadge(t, e)
                  , n = this.checkContentBadge(t);
                i && !n ? null === this || void 0 === this || this.classList.remove(this.hiddenClass) : null === this || void 0 === this || this.classList.add(this.hiddenClass)
            }
            ),
            I(this, "compareNumberFunc", (t, e, i) => {
                switch (i) {
                case "exact":
                    return t === e.from;
                case "above":
                    return t > e.from;
                case "below":
                    return t < e.from;
                case "exact_or_above":
                    return t >= e.from;
                case "exact_or_below":
                    return t <= e.from;
                case "between":
                    return t >= e.from && t <= e.to;
                default:
                    return !1
                }
            }
            ),
            I(this, "getMinValueForInventory", t => t === f.ABOVE ? 0 : t === f.BELOW ? 2 : 1),
            I(this, "inventoryTrigger", (t, e) => {
                if (void 0 === t.inventoryQuantity)
                    return !1;
                let i = null === t.inventory_management || t.inventory_policy == _.CONTINUE;
                if ("in_stock" === e.type) {
                    if (i)
                        return !0;
                    if (e.conditionType === f.BELOW || e.conditionType === f.EXACT_OR_BELOW) {
                        let i = this.getMinValueForInventory(e.conditionType);
                        return this.compareNumberFunc(null == t ? void 0 : t.inventoryQuantity, {
                            from: 1,
                            to: Number(e.from) - i + 1
                        }, f.BETWEEN)
                    }
                    return this.compareNumberFunc(null == t ? void 0 : t.inventoryQuantity, {
                        from: Number(e.from),
                        to: Number(null == e ? void 0 : e.to)
                    }, e.conditionType)
                }
                return !i && this.compareNumberFunc(t.inventoryQuantity, {
                    from: 0,
                    to: 0
                }, f.EXACT_OR_BELOW)
            }
            ),
            I(this, "discountPriceTrigger", (t, e) => {
                if ((null == t ? void 0 : t.compare_at_price) === void 0 || void 0 === t.price || t.compare_at_price < t.price)
                    return !1;
                let i = (t.compare_at_price - t.price) / 100
                  , n = i / (t.compare_at_price / 100)
                  , r = "fixed" === e.discountType ? i : Math.round(100 * n);
                return this.compareNumberFunc(r, {
                    from: Number(e.from),
                    to: Number(e.to)
                }, e.conditionType)
            }
            ),
            I(this, "priceRangeTrigger", (t, e) => {
                if (void 0 === t.price)
                    return !1;
                let i = t.price / 100;
                return this.compareNumberFunc(i, {
                    from: Number(e.from),
                    to: Number(e.to)
                }, e.conditionType)
            }
            ),
            I(this, "creationDateTrigger", (t, e) => {
                if (!t.product_created_at)
                    return !1;
                let i = new Date(new Date(t.product_created_at).setHours(0, 0, 0, 0))
                  , n = new Date(e.from)
                  , r = new Date(e.to)
                  , o = i.getTime();
                if ("exact_date" === e.type)
                    return this.compareNumberFunc(o, {
                        from: n.getTime(),
                        to: 0
                    }, f.EXACT);
                if ("duration" === e.type) {
                    let t = new Date().setHours(0, 0, 0, 0)
                      , n = (t - i.getTime()) / 864e5;
                    if (n >= 0 && n <= Number(e.days))
                        return !0
                }
                return !(n.getTime() >= r.getTime()) && this.compareNumberFunc(o, {
                    from: n.getTime(),
                    to: r.getTime()
                }, f.BETWEEN)
            }
            ),
            I(this, "productTagsTrigger", (t, e) => {
                let i = t.product_tags || []
                  , n = e.searchTag;
                return n.some(t => i.includes(t))
            }
            ),
            I(this, "getPrice", t => t.replace(/[%$]/g, "")),
            I(this, "checkDiscountContentProductBadge", t => !!t && /\{percent_discount\}|\{amount_discount\}/.test(t)),
            I(this, "checkContentBadge", t => {
                let e = this.checkDiscountContentProductBadge(this.dataset.displayContent)
                  , i = this.dataset.displayContent || this.getState("displayContent") || ""
                  , n = this.getState("isTextBadge") || !1
                  , r = n && !(null == i ? void 0 : i.trim())
                  , o = (null == t ? void 0 : t.compare_at_price) === void 0 || void 0 === t.price || t.compare_at_price <= t.price;
                return o && e || r
            }
            );
            let i = "true" === this.getState("isSettingSameHeightProductList");
            this.hiddenClass = i ? "!gp-invisible" : "!gp-hidden",
            this.bundleItem = e(this.productBundleItem),
            this.displayTrigger = this.getState("displayTrigger"),
            this.variantIDs = this.convertToArray(this.getState("variantIDs")),
            this.productCreatedAt = this.getState("productCreatedAt"),
            this.productTags = null === (t = this.getState("productTags")) || void 0 === t ? void 0 : t.split(","),
            this.variantInventoryQuantities = this.convertToArray(this.getState("variantInventoryQuantities"));
            let n = this.getContext("variantSelected");
            this.inventoryQuantity = this.getInventoryQuantity(n),
            n && this.applyInitialBadge(n)
        }
    }
    ;
    let N = () => {
        window.removeEventListener("gp-global-loaded", N),
        customElements.get("gp-product-badge") || customElements.define("gp-product-badge", S())
    }
    ;
    "completed" === window.gpReadyState ? N() : window.addEventListener("gp-global-loaded", N),
    t.defineComponentProductBadge = N
}({});
